import type { FaireProductEntity } from "../../entity_types/product";

export const p_cta164e: FaireProductEntity = {
  token: "p_cta164e",
  type: "product",
  name: "Gourmet Popcorn Mix",
  brandName: "Chelsea Snack Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/63ffb91816c25207723c2bcaf13ae379b45e654f4e4289d7b657811f9d25f688.webp",
  priceDollars: 10,
  description: "Handcrafted gourmet popcorn in sweet and savory flavors",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "artisanal"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/63ffb91816c25207723c2bcaf13ae379b45e654f4e4289d7b657811f9d25f688.webp",
  weight: 0.5,
  dimensions: {
    width: 5,
    height: 7,
    depth: 3,
  },
  inStock: true,
};
